// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';

import VueFire from 'vuefire';
import VueFuse from 'vue-fuse';
import Vuetify from 'vuetify';

import 'vuetify/dist/vuetify.min.css'; // Ensure you are using css-loader
import colors from 'vuetify/src/util/colors';

Vue.config.productionTip = false;

Vue.use(Vuetify, {
  theme: {
    'primary': colors.blue.base,
    'secondary': colors.red.base,
    'accent': colors.blue.base,
    'error': colors.red.base,
    'warning': colors.yellow.base,
    'info': colors.blue.base,
    'success': colors.green.base
  }
});
Vue.use(VueFuse);
Vue.use(VueFire);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {App}
});



// WEBPACK FOOTER //
// ./src/main.js